import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { CreateEventCommandInput, CreateEventCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'createEvent'];

export function useCreateEvent() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<CreateEventCommandOutput, Error, CreateEventCommandInput>({
    mutationKey: [...MUTATION_PREFIX],
    mutationFn: (input) => client.createEvent(input),
    retry: 2, // Automatically retry up to 2 times on failure
  });
}
